import ReportContent from "./templates/ReportContent"
import ChrTrackData from "../../../utils/ChrTrackData";

export const getProcessedTabsList = (tabsList, component) => {
  return tabsList.map((tab) => {
    return {
      ...tab,
      className: "pt-0",
      remoteOptions: {
        ...tab.remoteOptions,
        component: component || ReportContent,
        fetchOnlyOnce: true
      }
    }
  });
};

export const managementReportV2EventTracker = (eventName, additionalPayload = {}) => {
  if (eventName) {
    additionalPayload = {
      ...additionalPayload, ...{ eventCategory: ChrTrackData.Categories.MANAGEMENT_REPORT_V2 }
    };
    ChrAnalytics.trackEvent(eventName, additionalPayload);
  }
};
